import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between align-center mb-6" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "text-h4 font-weight-bold" }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "text-h4 font-weight-bold" }
const _hoisted_6 = { class: "d-flex align-center" }
const _hoisted_7 = { class: "text-h4 font-weight-bold" }
const _hoisted_8 = { class: "text-caption text-success" }
const _hoisted_9 = { class: "d-flex align-center" }
const _hoisted_10 = { class: "text-h4 font-weight-bold" }
const _hoisted_11 = { class: "text-h6 font-weight-bold" }
const _hoisted_12 = { class: "px-6" }
const _hoisted_13 = { class: "d-flex align-center" }
const _hoisted_14 = { class: "font-family-monospace text-body-2" }
const _hoisted_15 = { class: "font-weight-medium" }
const _hoisted_16 = { class: "text-caption text-medium-emphasis" }
const _hoisted_17 = {
  key: 0,
  class: "d-flex align-center"
}
const _hoisted_18 = { class: "font-weight-medium" }
const _hoisted_19 = {
  key: 1,
  class: "text-medium-emphasis"
}
const _hoisted_20 = {
  key: 0,
  class: "d-flex align-center"
}
const _hoisted_21 = {
  key: 1,
  class: "text-medium-emphasis"
}
const _hoisted_22 = {
  key: 0,
  class: "d-flex align-center"
}
const _hoisted_23 = {
  key: 1,
  class: "text-medium-emphasis"
}
const _hoisted_24 = { class: "text-body-2" }
const _hoisted_25 = { class: "text-caption text-medium-emphasis" }
const _hoisted_26 = { class: "text-body-2" }
const _hoisted_27 = { class: "text-caption text-medium-emphasis" }
const _hoisted_28 = { class: "text-body-2" }
const _hoisted_29 = { class: "text-caption text-medium-emphasis" }
const _hoisted_30 = { class: "d-flex gap-1" }
const _hoisted_31 = {
  key: 0,
  class: "d-flex justify-center align-center pa-4"
}
const _hoisted_32 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_33 = {
  key: 0,
  class: "position-relative mb-4"
}
const _hoisted_34 = { class: "text-body-2" }
const _hoisted_35 = {
  key: 0,
  class: "position-relative mb-4"
}
const _hoisted_36 = { class: "d-flex justify-space-between align-center mb-4" }
const _hoisted_37 = { class: "text-h6 font-weight-bold" }
const _hoisted_38 = { class: "text-body-2 text-medium-emphasis" }
const _hoisted_39 = { class: "text-h5 font-weight-bold text-primary" }
const _hoisted_40 = { class: "text-h5 font-weight-bold text-success" }
const _hoisted_41 = { class: "text-h6 font-weight-bold" }
const _hoisted_42 = { class: "text-body-2 text-medium-emphasis" }
const _hoisted_43 = { key: 0 }

import { ref, computed, onMounted } from 'vue'
import { useMeasurementsStore } from '@/views/DeviceSamples/store'
import { DeviceSample } from '@/views/DeviceSamples/models/deviceSample'
import { useDeviceStore } from '@/views/Devices/store'
import { useDeviceLoader } from '@/composables/useDeviceLoader'

// Store

export default /*@__PURE__*/_defineComponent({
  __name: 'DeviceSamplesView',
  setup(__props) {

const measurementsStore = useMeasurementsStore()
const deviceStore = useDeviceStore()
const deviceLoader = useDeviceLoader()

// Helper para obtener nombre del device por id
const getDeviceName = (deviceId: string): string => {
    const device = deviceStore.devices.find(d => d.id === deviceId)
    return device?.name || deviceId
}

const copiedId = ref('')
const copyToClipboard = async (text: string) => {
    await navigator.clipboard.writeText(text)
    copiedId.value = text
    setTimeout(() => { copiedId.value = '' }, 2000)
}

// Local state
const selectedMeasurement = ref<DeviceSample | null>(null)
const showEditDialog = ref(false)
const showViewDialog = ref(false)
const filterStatus = ref('all') // all, completed, pending
const searchQuery = ref('')
const itemsPerPage = ref(10)
const currentPage = ref(1)

// Form data for editing
const editForm = ref({
  growthPercent: 0,
  newRootsCount: 0,
  rootHealthScore: 5,
  rootColor: '',
  growthPattern: '',
  dominantDirection: '',
  fungalPresence: false,
  imageQuality: '',
  observation: ''
})

// Options for form selects
const rootColorOptions = [
  'Blanco saludable',
  'Blanco cremoso',
  'Amarillento claro',
  'Amarillento oscuro',
  'Marrón claro',
  'Marrón oscuro',
  'Gris',
  'Negro (deteriorado)'
]

const growthPatternOptions = [
  'Lineal',
  'Ramificada',
  'Ramificada densa',
  'Irregular',
  'Radial',
  'Espiral'
]

const directionOptions = [
  'Norte',
  'Norte-Este',
  'Este',
  'Sur-Este',
  'Sur',
  'Sur-Oeste',
  'Oeste',
  'Norte-Oeste',
  'Multidireccional',
  'Sin dirección clara'
]

const imageQualityOptions = [
  'Excelente',
  'Buena',
  'Media',
  'Baja',
  'Borrosa',
  'Inutilizable'
]

// Computed properties
const filteredMeasurements = computed(() => {
  let filtered = measurementsStore.deviceSamples

  // Filter by status
  if (filterStatus.value === 'completed') {
    filtered = filtered.filter(m => m.managed)
  } else if (filterStatus.value === 'pending') {
    filtered = filtered.filter(m => !m.managed)
  }

  // Filter by search query
  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase()
    filtered = filtered.filter(m =>
      m.id.toLowerCase().includes(query) ||
      m.deviceMeasurementsId.toLowerCase().includes(query) ||
      m.observation.toLowerCase().includes(query) ||
      m.rootColor.toLowerCase().includes(query)
    )
  }

  return filtered
})

const paginatedMeasurements = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value
  const end = start + itemsPerPage.value
  return filteredMeasurements.value.slice(start, end)
})

const totalPages = computed(() => {
  return Math.ceil(filteredMeasurements.value.length / itemsPerPage.value)
})

// Methods
const openEditDialog = (deviceSample: DeviceSample) => {
  selectedMeasurement.value = deviceSample
  editForm.value = {
    growthPercent: deviceSample.growthPercent,
    newRootsCount: deviceSample.newRootsCount,
    rootHealthScore: deviceSample.rootHealthScore,
    rootColor: deviceSample.rootColor,
    growthPattern: deviceSample.growthPattern,
    dominantDirection: deviceSample.dominantDirection,
    fungalPresence: deviceSample.fungalPresence,
    imageQuality: deviceSample.imageQuality,
    observation: deviceSample.observation
  }
  showEditDialog.value = true
}

const openViewDialog = (deviceSample: DeviceSample) => {
  selectedMeasurement.value = deviceSample
  showViewDialog.value = true
}

const closeEditDialog = () => {
  showEditDialog.value = false
  resetForm()
  selectedMeasurement.value = null
}

const closeViewDialog = () => {
  showViewDialog.value = false
  selectedMeasurement.value = null
}

const resetForm = () => {
  editForm.value = {
    growthPercent: 0,
    newRootsCount: 0,
    rootHealthScore: 5,
    rootColor: '',
    growthPattern: '',
    dominantDirection: '',
    fungalPresence: false,
    imageQuality: '',
    observation: ''
  }
}

const saveMeasurement = async () => {
  console.log('Saving measurement with form data:', editForm.value)
  if (!selectedMeasurement.value) {
    console.error('No measurement selected')
    return
  }

  try {
    const updatedMeasurement = new DeviceSample({
      ...selectedMeasurement.value,
      ...editForm.value,
      managed: true,
      managedAt: new Date(),
      updatedBy: 'admin' // TODO: Get from auth store
    })
    console.log('Saving deviceSample:', updatedMeasurement)
    await measurementsStore.putMeasurement(updatedMeasurement)

    // Cerrar ambos diálogos después de guardar exitosamente
    closeEditDialog()
    closeViewDialog()

    // Mostrar notificación de éxito (opcional)
    console.log('Medición guardada exitosamente')
  } catch (error) {
    console.error('Error al guardar medición:', error)
  }
}

const getStatusColor = (deviceSample: DeviceSample) => {
  if (deviceSample.managed) return 'success'

  const daysPending = deviceSample.getPendingDays()
  if (daysPending > 3) return 'error'
  if (daysPending > 1) return 'warning'
  return 'info'
}

const getStatusText = (deviceSample: DeviceSample) => {
  if (deviceSample.managed) return 'Completada'

  const daysPending = deviceSample.getPendingDays()
  if (daysPending > 3) return `Crítica (${daysPending}d)`
  if (daysPending > 1) return `Pendiente (${daysPending}d)`
  return 'Nueva'
}

const getPriorityIcon = (deviceSample: DeviceSample) => {
  if (deviceSample.managed) return 'mdi-check-circle'

  const daysPending = deviceSample.getPendingDays()
  if (daysPending > 3) return 'mdi-alert-octagon'
  if (daysPending > 1) return 'mdi-clock-alert'
  return 'mdi-clock-outline'
}

const formatDate = (date: Date) => {
  return date.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
}

// Lifecycle
onMounted(async () => {
  await Promise.all([
    measurementsStore.getMeasurements(),
    deviceLoader.loadDevicesByRole()
  ])
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _cache[17] || (_cache[17] = _createElementVNode("div", null, [
                  _createElementVNode("h1", { class: "text-h4 font-weight-bold" }, "Gestión de Mediciones"),
                  _createElementVNode("p", { class: "text-body-1 text-medium-emphasis" }, "Análisis manual de imágenes de crecimiento radicular")
                ], -1)),
                _createElementVNode("div", null, [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    "prepend-icon": "mdi-refresh",
                    onClick: _unref(measurementsStore).getMeasurements
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode(" Actualizar ")
                    ])),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "mb-6" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                flat: "",
                elevation: "2",
                class: "rounded-lg"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pb-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_v_avatar, {
                          color: "#FFF3E0",
                          size: "48",
                          class: "mr-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              color: "#FF9800",
                              size: "24"
                            }, {
                              default: _withCtx(() => _cache[18] || (_cache[18] = [
                                _createTextVNode("mdi-clipboard-list")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Total Mediciones", -1)),
                          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(measurementsStore).totalMeasurements), 1),
                          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-caption text-success" }, "Sistema activo", -1))
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_progress_linear, {
                        "model-value": "100",
                        height: "6",
                        color: "#FF9800",
                        rounded: ""
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                flat: "",
                elevation: "2",
                class: "rounded-lg"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pb-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_v_avatar, {
                          color: "#FFEBEE",
                          size: "48",
                          class: "mr-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              color: "#F44336",
                              size: "24"
                            }, {
                              default: _withCtx(() => _cache[21] || (_cache[21] = [
                                _createTextVNode("mdi-clock-alert")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Pendientes", -1)),
                          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(measurementsStore).uncompletedCount), 1),
                          _createElementVNode("div", {
                            class: _normalizeClass(["text-caption", _unref(measurementsStore).uncompletedCount > 5 ? 'text-error' : 'text-warning'])
                          }, _toDisplayString(_unref(measurementsStore).pendingOldest > 0 ? `Más antigua: ${_unref(measurementsStore).pendingOldest}d` : 'Al día'), 3)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_progress_linear, {
                        "model-value": (_unref(measurementsStore).uncompletedCount / _unref(measurementsStore).totalMeasurements) * 100,
                        height: "6",
                        color: "#F44336",
                        rounded: ""
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                flat: "",
                elevation: "2",
                class: "rounded-lg"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pb-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_v_avatar, {
                          color: "#E8F5E8",
                          size: "48",
                          class: "mr-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              color: "#4CAF50",
                              size: "24"
                            }, {
                              default: _withCtx(() => _cache[23] || (_cache[23] = [
                                _createTextVNode("mdi-check-circle")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Tasa de Finalización", -1)),
                          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(measurementsStore).completionRate) + "%", 1),
                          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(measurementsStore).completedCount) + " completadas", 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_progress_linear, {
                        "model-value": _unref(measurementsStore).completionRate,
                        height: "6",
                        color: "#4CAF50",
                        rounded: ""
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                flat: "",
                elevation: "2",
                class: "rounded-lg"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pb-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_v_avatar, {
                          color: "#E3F2FD",
                          size: "48",
                          class: "mr-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              color: "#2196F3",
                              size: "24"
                            }, {
                              default: _withCtx(() => _cache[25] || (_cache[25] = [
                                _createTextVNode("mdi-timer-outline")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Tiempo Promedio", -1)),
                          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(measurementsStore).averageResponseTime) + "h", 1),
                          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "text-caption text-info" }, "Por medición", -1))
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_progress_linear, {
                        "model-value": Math.min((24 - _unref(measurementsStore).averageResponseTime) / 24 * 100, 100),
                        height: "6",
                        color: "#2196F3",
                        rounded: ""
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                flat: "",
                elevation: "2",
                class: "rounded-lg"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: searchQuery.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                                label: "Buscar mediciones",
                                "prepend-inner-icon": "mdi-magnify",
                                variant: "outlined",
                                density: "comfortable",
                                "hide-details": "",
                                clearable: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                modelValue: filterStatus.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterStatus).value = $event)),
                                items: [
                  { title: 'Todas las mediciones', value: 'all' },
                  { title: 'Completadas', value: 'completed' },
                  { title: 'Pendientes', value: 'pending' }
                ],
                                label: "Estado",
                                variant: "outlined",
                                density: "comfortable",
                                "hide-details": ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                modelValue: itemsPerPage.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((itemsPerPage).value = $event)),
                                items: [5, 10, 25, 50],
                                label: "Elementos por página",
                                variant: "outlined",
                                density: "comfortable",
                                "hide-details": ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "mt-6" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                flat: "",
                elevation: "2",
                class: "rounded-lg"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center px-6 py-4" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _cache[28] || (_cache[28] = _createTextVNode(" Mediciones ")),
                        _createVNode(_component_v_chip, {
                          size: "small",
                          color: "primary",
                          class: "ml-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(filteredMeasurements.value.length), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, { class: "px-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_table, null, {
                        default: _withCtx(() => [
                          _cache[37] || (_cache[37] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", { class: "text-left px-6" }, "ID"),
                              _createElementVNode("th", { class: "text-left" }, "Dispositivo"),
                              _createElementVNode("th", { class: "text-left" }, "Estado"),
                              _createElementVNode("th", { class: "text-left" }, "Crecimiento"),
                              _createElementVNode("th", { class: "text-left" }, "Salud"),
                              _createElementVNode("th", { class: "text-left" }, "Raíces Nuevas"),
                              _createElementVNode("th", { class: "text-left" }, "Tiene foto"),
                              _createElementVNode("th", { class: "text-left" }, "Creada"),
                              _createElementVNode("th", { class: "text-left" }, "Actualizada"),
                              _createElementVNode("th", { class: "text-left" }, "Acciones")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedMeasurements.value, (deviceSample) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: deviceSample.id,
                                class: _normalizeClass(["deviceSample-row", { 'priority-high': !deviceSample.managed && deviceSample.getPendingDays() > 3 }])
                              }, [
                                _createElementVNode("td", _hoisted_12, [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_component_v_icon, {
                                      icon: getPriorityIcon(deviceSample),
                                      color: getStatusColor(deviceSample),
                                      size: "16",
                                      class: "mr-2"
                                    }, null, 8, ["icon", "color"]),
                                    _createElementVNode("span", _hoisted_14, _toDisplayString(deviceSample.id.slice(0, 8)) + "...", 1),
                                    _createVNode(_component_v_btn, {
                                      icon: "",
                                      size: "x-small",
                                      variant: "text",
                                      onClick: ($event: any) => (copyToClipboard(deviceSample.id))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "14" }, {
                                          default: _withCtx(() => _cache[29] || (_cache[29] = [
                                            _createTextVNode("mdi-content-copy")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_tooltip, {
                                          activator: "parent",
                                          location: "top"
                                        }, {
                                          default: _withCtx(() => _cache[30] || (_cache[30] = [
                                            _createTextVNode("Copiar ID completo")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_15, _toDisplayString(getDeviceName(deviceSample.deviceId)), 1),
                                  _createElementVNode("div", _hoisted_16, _toDisplayString(deviceSample.deviceId), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_v_chip, {
                                    color: getStatusColor(deviceSample),
                                    size: "small",
                                    "text-color": "white"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(getStatusText(deviceSample)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"])
                                ]),
                                _createElementVNode("td", null, [
                                  (deviceSample.managed)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        _createElementVNode("span", _hoisted_18, _toDisplayString(deviceSample.growthPercent) + "%", 1),
                                        _createVNode(_component_v_chip, {
                                          size: "x-small",
                                          color: deviceSample.growthPercent >= 3 ? 'success' : deviceSample.growthPercent >= 1 ? 'warning' : 'default',
                                          class: "ml-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(deviceSample.getGrowthCategory()), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["color"])
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_19, "-"))
                                ]),
                                _createElementVNode("td", null, [
                                  (deviceSample.managed)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                        _createVNode(_component_v_icon, {
                                          color: deviceSample.getHealthScoreColor(),
                                          size: "16",
                                          class: "mr-1"
                                        }, {
                                          default: _withCtx(() => _cache[31] || (_cache[31] = [
                                            _createTextVNode(" mdi-heart ")
                                          ])),
                                          _: 2
                                        }, 1032, ["color"]),
                                        _createElementVNode("span", null, _toDisplayString(deviceSample.rootHealthScore) + "/10", 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_21, "-"))
                                ]),
                                _createElementVNode("td", null, [
                                  (deviceSample.managed)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                        _createVNode(_component_v_icon, {
                                          color: "success",
                                          size: "16",
                                          class: "mr-1"
                                        }, {
                                          default: _withCtx(() => _cache[32] || (_cache[32] = [
                                            _createTextVNode("mdi-sprout")
                                          ])),
                                          _: 1
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(deviceSample.newRootsCount), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_23, "-"))
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_24, _toDisplayString(deviceSample.imageUrl? 'Sí' : 'No'), 1),
                                  _createElementVNode("div", _hoisted_25, _toDisplayString(deviceSample.createdBy), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_26, _toDisplayString(formatDate(deviceSample.time)), 1),
                                  _createElementVNode("div", _hoisted_27, _toDisplayString(deviceSample.createdBy), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_28, _toDisplayString(formatDate(deviceSample.updatedAt)), 1),
                                  _createElementVNode("div", _hoisted_29, _toDisplayString(deviceSample.updatedBy || '-'), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_30, [
                                    _createVNode(_component_v_btn, {
                                      icon: "",
                                      size: "small",
                                      color: "primary",
                                      variant: "text",
                                      onClick: ($event: any) => (openEditDialog(deviceSample))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "18" }, {
                                          default: _withCtx(() => _cache[33] || (_cache[33] = [
                                            _createTextVNode("mdi-pencil")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_tooltip, {
                                          activator: "parent",
                                          location: "top"
                                        }, {
                                          default: _withCtx(() => _cache[34] || (_cache[34] = [
                                            _createTextVNode("Completar análisis")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_v_btn, {
                                      icon: "",
                                      size: "small",
                                      color: "info",
                                      variant: "text",
                                      onClick: ($event: any) => (openViewDialog(deviceSample))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "18" }, {
                                          default: _withCtx(() => _cache[35] || (_cache[35] = [
                                            _createTextVNode("mdi-eye")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_tooltip, {
                                          activator: "parent",
                                          location: "top"
                                        }, {
                                          default: _withCtx(() => _cache[36] || (_cache[36] = [
                                            _createTextVNode("Ver detalles")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ])
                              ], 2))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }),
                      (totalPages.value > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createVNode(_component_v_pagination, {
                              modelValue: currentPage.value,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentPage).value = $event)),
                              length: totalPages.value,
                              "total-visible": 7,
                              color: "primary"
                            }, null, 8, ["modelValue", "length"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: showEditDialog.value,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((showEditDialog).value = $event)),
        "max-width": "800",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-h5 px-6 py-4 bg-primary text-white" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { class: "mr-2" }, {
                    default: _withCtx(() => _cache[38] || (_cache[38] = [
                      _createTextVNode("mdi-clipboard-edit")
                    ])),
                    _: 1
                  }),
                  _cache[39] || (_cache[39] = _createTextVNode(" Completar Análisis de Medición "))
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "pa-6" }, {
                default: _withCtx(() => [
                  (selectedMeasurement.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        (selectedMeasurement.value.imageUrl)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              _createVNode(_component_v_img, {
                                src: selectedMeasurement.value.imageUrl,
                                "max-height": "300",
                                class: "rounded-lg",
                                cover: ""
                              }, {
                                placeholder: _withCtx(() => [
                                  _createVNode(_component_v_row, {
                                    class: "fill-height ma-0",
                                    align: "center",
                                    justify: "center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_progress_circular, {
                                        indeterminate: "",
                                        color: "primary"
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["src"]),
                              _createVNode(_component_v_btn, {
                                icon: "",
                                size: "small",
                                color: "white",
                                class: "position-absolute",
                                style: {"top":"8px","right":"8px"},
                                href: selectedMeasurement.value.imageUrl,
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { size: "18" }, {
                                    default: _withCtx(() => _cache[40] || (_cache[40] = [
                                      _createTextVNode("mdi-open-in-new")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_tooltip, {
                                    activator: "parent",
                                    location: "top"
                                  }, {
                                    default: _withCtx(() => _cache[41] || (_cache[41] = [
                                      _createTextVNode("Abrir imagen en nueva pestaña")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["href"])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_alert, {
                          type: "info",
                          variant: "tonal",
                          class: "mb-4"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_34, [
                              _cache[42] || (_cache[42] = _createElementVNode("strong", null, "ID:", -1)),
                              _createTextVNode(" " + _toDisplayString(selectedMeasurement.value.id), 1),
                              _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1)),
                              _cache[44] || (_cache[44] = _createElementVNode("strong", null, "Dispositivo:", -1)),
                              _createTextVNode(" " + _toDisplayString(selectedMeasurement.value.deviceMeasurementsId), 1),
                              _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
                              _cache[46] || (_cache[46] = _createElementVNode("strong", null, "Creada:", -1)),
                              _createTextVNode(" " + _toDisplayString(formatDate(selectedMeasurement.value.createdAt)), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_form, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: editForm.value.growthPercent,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editForm.value.growthPercent) = $event)),
                                modelModifiers: { number: true },
                                label: "Porcentaje de Crecimiento (%)",
                                type: "number",
                                step: "0.1",
                                min: "0",
                                max: "100",
                                variant: "outlined",
                                density: "comfortable",
                                suffix: "%",
                                rules: [v => v >= 0 || 'Debe ser mayor o igual a 0']
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: editForm.value.newRootsCount,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editForm.value.newRootsCount) = $event)),
                                modelModifiers: { number: true },
                                label: "Cantidad de Raíces Nuevas",
                                type: "number",
                                min: "0",
                                variant: "outlined",
                                density: "comfortable",
                                rules: [v => v >= 0 || 'Debe ser mayor o igual a 0']
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_slider, {
                                modelValue: editForm.value.rootHealthScore,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editForm.value.rootHealthScore) = $event)),
                                label: "Puntaje de Salud Radicular",
                                min: "1",
                                max: "10",
                                step: "1",
                                "thumb-label": "",
                                "show-ticks": "",
                                "tick-size": "4",
                                color: editForm.value.rootHealthScore >= 7 ? 'success' : editForm.value.rootHealthScore >= 4 ? 'warning' : 'error'
                              }, null, 8, ["modelValue", "color"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                modelValue: editForm.value.imageQuality,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editForm.value.imageQuality) = $event)),
                                items: imageQualityOptions,
                                label: "Calidad de Imagen",
                                variant: "outlined",
                                density: "comfortable",
                                rules: [v => !!v || 'Campo requerido']
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                modelValue: editForm.value.rootColor,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editForm.value.rootColor) = $event)),
                                items: rootColorOptions,
                                label: "Color de Raíces",
                                variant: "outlined",
                                density: "comfortable",
                                rules: [v => !!v || 'Campo requerido']
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                modelValue: editForm.value.growthPattern,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editForm.value.growthPattern) = $event)),
                                items: growthPatternOptions,
                                label: "Patrón de Crecimiento",
                                variant: "outlined",
                                density: "comfortable",
                                rules: [v => !!v || 'Campo requerido']
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                modelValue: editForm.value.dominantDirection,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editForm.value.dominantDirection) = $event)),
                                items: directionOptions,
                                label: "Dirección Dominante",
                                variant: "outlined",
                                density: "comfortable"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: editForm.value.fungalPresence,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editForm.value.fungalPresence) = $event)),
                                label: "Presencia de Hongos o Daños",
                                color: "warning"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_textarea, {
                                modelValue: editForm.value.observation,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((editForm.value.observation) = $event)),
                                label: "Observaciones Generales",
                                variant: "outlined",
                                rows: "4",
                                placeholder: "Describe cualquier observación adicional sobre el crecimiento radicular..."
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "px-6 pb-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: closeEditDialog
                  }, {
                    default: _withCtx(() => _cache[47] || (_cache[47] = [
                      _createTextVNode(" Cancelar ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    onClick: saveMeasurement,
                    loading: _unref(measurementsStore).loading
                  }, {
                    default: _withCtx(() => _cache[48] || (_cache[48] = [
                      _createTextVNode(" Guardar Análisis ")
                    ])),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: showViewDialog.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((showViewDialog).value = $event)),
        "max-width": "700"
      }, {
        default: _withCtx(() => [
          (selectedMeasurement.value)
            ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "text-h5 px-6 py-4 bg-info text-white" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "mr-2" }, {
                        default: _withCtx(() => _cache[49] || (_cache[49] = [
                          _createTextVNode("mdi-eye")
                        ])),
                        _: 1
                      }),
                      _cache[50] || (_cache[50] = _createTextVNode(" Detalles de Medición "))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, { class: "pa-6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              (selectedMeasurement.value.imageUrl)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    _createVNode(_component_v_img, {
                                      src: selectedMeasurement.value.imageUrl,
                                      "max-height": "350",
                                      class: "rounded-lg",
                                      cover: ""
                                    }, {
                                      placeholder: _withCtx(() => [
                                        _createVNode(_component_v_row, {
                                          class: "fill-height ma-0",
                                          align: "center",
                                          justify: "center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_progress_circular, {
                                              indeterminate: "",
                                              color: "primary"
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["src"]),
                                    _createVNode(_component_v_btn, {
                                      icon: "",
                                      size: "small",
                                      color: "white",
                                      class: "position-absolute",
                                      style: {"top":"8px","right":"8px"},
                                      href: selectedMeasurement.value.imageUrl,
                                      target: "_blank"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "18" }, {
                                          default: _withCtx(() => _cache[51] || (_cache[51] = [
                                            _createTextVNode("mdi-open-in-new")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_tooltip, {
                                          activator: "parent",
                                          location: "top"
                                        }, {
                                          default: _withCtx(() => _cache[52] || (_cache[52] = [
                                            _createTextVNode("Abrir imagen en nueva pestaña")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["href"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_37, _toDisplayString(selectedMeasurement.value.id), 1),
                                  _createElementVNode("div", _hoisted_38, _toDisplayString(selectedMeasurement.value.deviceMeasurementsId), 1)
                                ]),
                                _createVNode(_component_v_chip, {
                                  color: getStatusColor(selectedMeasurement.value),
                                  "text-color": "white"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(getStatusText(selectedMeasurement.value)), 1)
                                  ]),
                                  _: 1
                                }, 8, ["color"])
                              ])
                            ]),
                            _: 1
                          }),
                          (selectedMeasurement.value.managed)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        md: "3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card, {
                                            variant: "outlined",
                                            class: "pa-3 text-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_39, _toDisplayString(selectedMeasurement.value.growthPercent) + "%", 1),
                                              _cache[53] || (_cache[53] = _createElementVNode("div", { class: "text-caption" }, "Crecimiento", -1))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        md: "3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card, {
                                            variant: "outlined",
                                            class: "pa-3 text-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_40, _toDisplayString(selectedMeasurement.value.newRootsCount), 1),
                                              _cache[54] || (_cache[54] = _createElementVNode("div", { class: "text-caption" }, "Raíces Nuevas", -1))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        md: "3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card, {
                                            variant: "outlined",
                                            class: "pa-3 text-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", {
                                                class: "text-h5 font-weight-bold",
                                                style: _normalizeStyle({ color: selectedMeasurement.value.getHealthScoreColor() })
                                              }, _toDisplayString(selectedMeasurement.value.rootHealthScore) + "/10 ", 5),
                                              _cache[55] || (_cache[55] = _createElementVNode("div", { class: "text-caption" }, "Salud", -1))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "6",
                                        md: "3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card, {
                                            variant: "outlined",
                                            class: "pa-3 text-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_41, _toDisplayString(selectedMeasurement.value.getGrowthCategory()), 1),
                                              _cache[56] || (_cache[56] = _createElementVNode("div", { class: "text-caption" }, "Categoría", -1))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_divider, { class: "my-4" }),
                                  _createVNode(_component_v_list, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => _cache[57] || (_cache[57] = [
                                              _createTextVNode("Color de Raíces")
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item_subtitle, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(selectedMeasurement.value.rootColor || 'No especificado'), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_list_item, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => _cache[58] || (_cache[58] = [
                                              _createTextVNode("Patrón de Crecimiento")
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item_subtitle, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(selectedMeasurement.value.growthPattern || 'No especificado'), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_list_item, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => _cache[59] || (_cache[59] = [
                                              _createTextVNode("Dirección Dominante")
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item_subtitle, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(selectedMeasurement.value.dominantDirection || 'No especificado'), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_list_item, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => _cache[60] || (_cache[60] = [
                                              _createTextVNode("Calidad de Imagen")
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item_subtitle, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(selectedMeasurement.value.imageQuality || 'No especificado'), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_list_item, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => _cache[61] || (_cache[61] = [
                                              _createTextVNode("Presencia de Hongos")
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item_subtitle, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_chip, {
                                                size: "small",
                                                color: selectedMeasurement.value.fungalPresence ? 'error' : 'success',
                                                "text-color": "white"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(selectedMeasurement.value.fungalPresence ? 'Sí' : 'No'), 1)
                                                ]),
                                                _: 1
                                              }, 8, ["color"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      (selectedMeasurement.value.observation)
                                        ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => _cache[62] || (_cache[62] = [
                                                  _createTextVNode("Observaciones")
                                                ])),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(selectedMeasurement.value.observation), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                cols: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_alert, {
                                    type: "warning",
                                    variant: "tonal"
                                  }, {
                                    default: _withCtx(() => _cache[63] || (_cache[63] = [
                                      _createTextVNode(" Esta medición aún no ha sido completada. Requiere análisis manual. ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_divider, { class: "mb-4" }),
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("div", null, [
                                  _cache[64] || (_cache[64] = _createElementVNode("strong", null, "Creada:", -1)),
                                  _createTextVNode(" " + _toDisplayString(formatDate(selectedMeasurement.value.createdAt)) + " por " + _toDisplayString(selectedMeasurement.value.createdBy), 1)
                                ]),
                                (selectedMeasurement.value.managed)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                      _cache[65] || (_cache[65] = _createElementVNode("strong", null, "Completada:", -1)),
                                      _createTextVNode(" " + _toDisplayString(formatDate(selectedMeasurement.value.managedAt)) + " por " + _toDisplayString(selectedMeasurement.value.updatedBy), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_actions, { class: "px-6 pb-4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_spacer),
                      (!selectedMeasurement.value.managed)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            color: "primary",
                            "prepend-icon": "mdi-pencil",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (openEditDialog(selectedMeasurement.value)))
                          }, {
                            default: _withCtx(() => _cache[66] || (_cache[66] = [
                              _createTextVNode(" Completar Análisis ")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_btn, {
                        variant: "text",
                        onClick: closeViewDialog
                      }, {
                        default: _withCtx(() => _cache[67] || (_cache[67] = [
                          _createTextVNode(" Cerrar ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})